// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QXcbvbcjFHUJLk {
  display: flex;
  align-items: center;
  align-self: stretch;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding: 14px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logoLink": `QXcbvbcjFHUJLk`
};
export default ___CSS_LOADER_EXPORT___;
